/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import { Line } from "rc-progress";

//import { AnimateOnChange } from 'react-animation'
//import { AnimateKeyframes }  from 'react-simple-animate';
//import { throttle, debounce } from 'throttle-debounce';
//import LinesEllipsis from 'react-lines-ellipsis'
//import EllipsisText from "react-ellipsis-text";
import ReactHoverObserver from 'react-hover-observer';
import ReactPlayer from 'react-player';
import { Modal } from 'react-responsive-modal';
import axios from 'axios';
// import Items from "../pages/Items";
import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import moment from 'moment';
import UsePoint from '../containers/point/UsePoint';
import Tooltip from '@material-ui/core/Tooltip';
import { Base64 } from 'js-base64';
import { isMobile, isAndroid, isIOS } from 'react-device-detect';

class ContentItemWide extends Component {
  state = {
    itemShow: false,
    wishFlag: this.props.childProps.wishFlag
      ? this.props.childProps.wishFlag
      : 0,
    playIcon: false,
    modalShow: false,
    payGubun: '',
  };
  path = '';
  componentDidMount = () => {
    const { history } = this.props;
    this.path = history.location.pathname;
    this._getWindowSize();
    window.addEventListener('resize', this._getWindowSize);
  };
  componentWillUnmount = () => {
    window.removeEventListener('resize', this._getWindowSize);
  };
  _getWindowSize = () => {
    ////console.log(window.innerWidth)
    //const hSize = (window.innerWidth-18) * (322/181)
    ////console.log('hSize')
    ////console.log(hSize)

    const wSizeRatio = parseInt(window.innerWidth - 18) / parseFloat(6.4);
    const wSizeOver = parseInt(window.innerWidth - 18) / parseFloat(3.89);
    const hSize = wSizeOver * (287 / 493);
    const fSize = parseInt(window.innerWidth - 18) / parseFloat(137);
    const fSizeSmail = parseInt(window.innerWidth - 18) / parseFloat(160);
    ////console.log(window.innerWidth-1)
    ////console.log(wSizeRatio)
    //493 * 287 도영상
    this.setState({
      wSize: wSizeRatio, //wSizeRatio > 282 ? 282 : wSizeRatio
      wSizeOver: wSizeOver, //wSizeOver > 489 ? 489 : wSizeOver
      hSize: hSize,
      fSize: fSize > 14 ? 14 : fSize,
      fSizeSmail: fSizeSmail > 12 ? 12 : fSizeSmail,
    });
  };
  _onPlay = async (e) => {
    const {
      history,
      loginId,
      setPlayUrl,
      aParam,
      setContentSerial,
      serviceEndDate,
    } = this.props;
    const {
      contentSerial,
      contentPartSerial,
      subPartSerial2,
      subPartSerial3,
      part,
      playToggle,
      liveStop,
    } = this.props.childProps;
    let target;

    if (moment(new Date()).format('YYYY-MM-DD HH:mm:ss') > serviceEndDate) {
      alert('VOD 서비스가 종료되었습니다.');
      return null;
    }

    if (e) {
      target = e.currentTarget.className;
      e.stopPropagation();
    } else {
      target = 'list_img_play';
    }

    if (target === 'list_img_bg' || target === 'list_img_more') {
      if (this.path === '/live') {
        if (this.props.contentSerial > 0) {
          //console.log('삭제 후 이동')
          setContentSerial(0);

          setTimeout(() => {
            setContentSerial(contentSerial);
          }, 300);
        } else {
          //console.log('이동')
          setContentSerial(contentSerial);
        }
      } else {
        if (this.props.contentSerial > 0) {
          //console.log('삭제 후 이동')
          setContentSerial(0);

          setTimeout(() => {
            history.push('/items/' + contentSerial);
          }, 300);
        } else {
          //console.log('이동')
          history.push('/items/' + contentSerial);
        }
      }
    } else if (target === 'list_img_play') {
      if (isMobile) {
        alert(
          '모바일 웹브라우져에서는 VOD 스트리밍을 지원하지 않습니다.\n\n확인을 누르시면 전용앱 또는 스토어로 이동합니다.'
        );
        this._moveStore();
        return false;
      }

      if (loginId === '' || loginId === undefined || loginId === null) {
        toast.warn('로그인후 관람이 가능합니다.');
        history.push('/login');
        return false;
      } else {
        if (
          contentPartSerial === undefined ||
          contentPartSerial === null ||
          contentPartSerial === ''
        ) {
          toast.warn('파라메터가 누락되었습니다.');
        } else {
          if (playToggle) {
            playToggle();
          }
          if (liveStop) {
            liveStop();
          }

          //console.log(contentPartSerial, subPartSerial2, subPartSerial3)

          const date = new Date();
          const timeStemp = moment(date)
            .add(10, 'minutes')
            .format('YYYYMMDDHHmmss');
          //let param = this.encode(timeStemp)

          //let crypParam = timeStemp + '|aniplus|' + subPartSerial2 + '/' + loginId
          let crypParam =
            timeStemp + '|was|' + subPartSerial2 + '/' + loginId + '@' + aParam;
          const base64Data = await this._getBase64Encode(crypParam);
          crypParam = base64Data.data.codeString;

          let urlEncode =
            contentPartSerial +
            '|' +
            subPartSerial2 +
            '|' +
            subPartSerial3 +
            '|' +
            part;
          const base64Data1 = await this._getBase64Encode(urlEncode);
          urlEncode = base64Data1.data.codeString;

          const result = await this._onPlayApi(subPartSerial2, crypParam);
          if (result) {
            const intReturn = result.data[0].intReturn;
            //console.log(intReturn)
            if (intReturn === 0 || intReturn === 10) {
              //onCloseModal()
              setPlayUrl(urlEncode);
              //history.push('/player/?u=' + urlEncode)
            } else if (intReturn === -7 || intReturn === -1) {
              toast.error('서비스 중인 콘텐츠가 아닙니다.');
              //alert('서비스 중인 콘텐츠가 아닙니다.')
            } else if (intReturn === -4 || intReturn === -5) {
              //alert('이용권 또는 포인트 구매 후 관람이 가능합니다.')
              toast.warn('이용권 또는 포인트 충전후 관람이 가능합니다');
            } else if (intReturn === -2) {
              toast.warn('19세 미만은 관람이 불가한 작품입니다.');
              //alert('19세 미만은 관람이 불가한 작품입니다.')
            } else if (intReturn === -3) {
              //포인트 결제창 뛰울것
              this._onShowModal('vod');
            } else {
              toast.error('오류가 발생했습니다.');
              //alert('오류가 발생했습니다.')
            }
          }
        }
      }
    }
    //console.log('play')
  };
  _onPlayApi = (subPartSerial, crypParam) => {
    const { apiUrl, loginId, authId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');

    let token = new Date();
    token = moment(token).format('YYYYMMDDhhmmss');
    token = Base64.encode(token);

    return axios
      .post(
        apiUrl + '/vodUrl',
        {
          params: {
            userid: loginId,
            authId: authId,
            subPartSerial: subPartSerial,
            //param: param,
            crypParam: crypParam,
            token: token,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(0);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (gubun) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');

    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      if (gubun === 0) {
        this._onPlay();
      } else if (gubun === 1) {
        this._setPointUse();
      }
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _onShowModal = (payGubun) => {
    //alert(0)
    this.setState({
      payGubun: payGubun,
      modalShow: true,
    });
  };

  _setPointUse = async () => {
    const { loginId } = this.props;
    const { payGubun } = this.state;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._setPointUseApi();
      if (result) {
        const intReturn = result.data[0].intReturn;
        if (intReturn === 0) {
          this.setState({
            modalShow: false,
          });
          if (payGubun === 'down') {
            this._onDownload();
          } else {
            this._onPlay();
          }

          ////console.log('다운로드 시작.')
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };

  _setPointUseApi = () => {
    const { payGubun } = this.state;
    const { contentSerial, subPartSerial2 } = this.props.childProps;

    const { apiUrl, loginId, authId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');
    //console.log(apiUrl + '/setUsePoint?userid=' + loginId + '&CheckedItems=' + subPartSerial2 + ',' + '&contentSerial=' + contentSerial + '&gubun=' + payGubun )
    //return axios(apiUrl + '/setUsePoint?userid=' + loginId + '&CheckedItems=' + subPartSerial2 + ',' + '&contentSerial=' + contentSerial + '&gubun=' + payGubun + '&chksale=ppv' )
    return axios
      .post(
        apiUrl + '/setUsePoint',
        {
          params: {
            userid: loginId,
            authId: authId,
            CheckedItems: subPartSerial2 + ',',
            contentSerial: contentSerial,
            gubun: payGubun,
            chksale: 'ppv',
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //toast.error('포인트 정보를 로드중 오류가 발생했습니다.')
        //alert('포인트 정보를 로드중 오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(1);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };

  /*
    componentDidMount = () => {

    }
    UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
        // return false 하면 업데이트를 안함
        return this.props.childProps.goodSerial !== nextProps.childProps.goodSerial
        //return true;
    }
    componentWillReceiveProps = (nextProps) => {
        if(this.props.childProps.goodSerial !== nextProps.childProps.goodSerial) {
            this._getItem(nextProps.childProps.goodSerial)
            window.scrollTo(0, 0)
        }
    }
    */
  _goItem = (contentSerial) => {
    const { history, setContentSerial } = this.props;

    if (this.path === '/live') {
      if (this.props.contentSerial > 0) {
        //console.log('삭제 후 이동')
        setContentSerial(0);

        setTimeout(() => {
          setContentSerial(contentSerial);
        }, 300);
      } else {
        //console.log('이동')
        setContentSerial(contentSerial);
      }
    } else {
      if (this.props.contentSerial > 0) {
        //console.log('삭제 후 이동')
        setContentSerial(0);

        setTimeout(() => {
          history.push('/items/' + contentSerial);
        }, 300);
      } else {
        //console.log('이동')
        history.push('/items/' + contentSerial);
      }
    }

    //history.push('/items/' + contentSerial)
    //setContentSerial(contentSerial)
    /*
        this.setState({
            itemShow: true
        })
        */
  };
  /*
    _onCloseModal = () => {
        this.setState({
            itemShow: false
        })
    }
    */
  _onCloseModal = () => {
    this.setState({
      modalShow: false,
    });
  };
  /*
    _onToggelMouseOn = (e) => {
        ////console.log('cccc')
        //e.stopPropagation()
        
        this.setState({
            mouseOn: true
        })
    }
    _onToggelMouseOut = (e) => {
        ////console.log('bbb')
        //e.stopPropagation()
        this.setState({
            mouseOn: false,
        })
    }
    */
  _timeToMs = (time) => {
    const tt = time.split(':');
    const sec =
      parseInt(tt[0]) * 3600 + parseInt(tt[1]) * 60 + parseInt(tt[2]) * 1;
    return sec;
    ////console.log(sec)
  };
  _toggleWish = async () => {
    const { onInit, menuIndex } = this.props.childProps;
    const { loginId } = this.props;
    // const { wishFlag } = this.state;

    //console.log(contentSerial, wishFlag)

    if (loginId === '' || loginId === null || loginId === undefined) {
      toast.warn('로그인 후 이용해 주세요.');
    } else {
      const result = await this._toggleWishApi();
      const intReturn = result.data[0].intReturn; // 0 삭제됨 100 추가됨

      this.setState({
        wishFlag: intReturn,
      });
      //console.log(intReturn)
      if (intReturn === 0) {
        if (onInit) {
          if (menuIndex === 1) {
            setTimeout(() => {
              onInit('/viewContent');
            }, 700);
          }
        }
      }
    }
  };
  _toggleWishApi = () => {
    const { apiUrl, loginId } = this.props;
    const { contentSerial } = this.props.childProps;

    return axios
      .post(apiUrl + '/wishToggle', {
        params: {
          userid: loginId,
          contentSerial: contentSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        toast.error('오류가 발생했습니다.');
        //alert('오류가 발생했습니다.')
      });
  };
  _togglePlayOn = () => {
    const { playIcon } = this.state;
    this.setState({
      playIcon: !playIcon,
    });
  };
  _getBase64Encode = (codeString) => {
    const { aspUrl, pkg, loginId } = this.props;
    return axios(
      aspUrl +
        '/base64encode_wd.asp?codeString=' +
        codeString +
        '&p=' +
        pkg +
        '&i=' +
        loginId
    )
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _getBase64Decode = (codeString) => {
    const { aspUrl } = this.props;
    //console.log(aspUrl + '/base64decode.asp?codeString=' + codeString)
    return axios(aspUrl + '/base64decode.asp?codeString=' + codeString)
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _onHoverChange = (isHovering) => {
    const { num, onEndItemSlide } = this.props.childProps;
    if (onEndItemSlide) {
      onEndItemSlide(num, isHovering.isHovering);
    }
  };
  _moveStore = () => {
    const { match } = this.props;

    if (isIOS) {
      console.log('ios');
      setTimeout(function () {
        window.open('https://itunes.apple.com/kr/app/id687631772', '', '');
      }, 1500);

      window.location.href = 'aniplustv://';
    } else if (isAndroid) {
      console.log('andorid');
      setTimeout(function () {
        window.open(
          'https://play.google.com/store/apps/details?id=com.aniplustv.android',
          '',
          ''
        );
      }, 1500);

      window.location.href = 'aniplustv://';
    } else {
      setTimeout(function () {
        window.open(
          'https://play.google.com/store/apps/details?id=com.aniplustv.android',
          '',
          ''
        );
      }, 1500);
    }
  };
  render() {
    const { wSize, wSizeOver, hSize, wishFlag, playIcon, modalShow, payGubun } =
      this.state;
    const { imgUrl } = this.props;
    const {
      refer,
      title,
      subTitle,
      img,
      overImg,
      contentSerial,
      contentPartSerial,
      pos,
      mediaTime,
      dRank,
      opening,
      subPartSerial2,
      subPartSerial3,
    } = this.props.childProps;
    ////console.log(pos/this._timeToMs(mediaTime) * 100)
    const ratio = (pos / this._timeToMs(mediaTime)) * 100;
    ////console.log(pos, mediaTime, this._timeToMs(mediaTime) * 100, ratio)
    ////console.log(wSize)

    return (
      /*282*/
      <Fragment>
        <ReactHoverObserver
          hoverDelayInMs={700}
          hoverOffDelayInMs={400}
          onHoverChanged={this._onHoverChange}
        >
          {({ isHovering }) => (
            <div style={{ paddingTop: 30 }}>
              <div
                className={isHovering ? 'list_paly1_on div_li' : 'div_li'}
                style={
                  isHovering
                    ? isMobile
                      ? null
                      : {
                          transition: 'all ease 0.7s',
                          width: wSizeOver,
                          textAlign: 'center',
                          transformOrigin: 'center center',
                        }
                    : {
                        transition: 'all ease 0.3s',
                        width: wSize,
                        textAlign: 'center',
                        transformOrigin: 'center center',
                      }
                }
              >
                {!isHovering ? (
                  dRank >= 10 ? (
                    <em>
                      <img src={imgUrl + '/img/top10.png'} />
                    </em>
                  ) : null
                ) : (
                  <Fragment>
                    <Tooltip title="관람하기">
                      <div
                        className="list_img_play"
                        onClick={this._onPlay}
                        onMouseEnter={this._togglePlayOn}
                        onMouseLeave={this._togglePlayOn}
                      >
                        {playIcon ? (
                          <img src={imgUrl + '/img/play2_on.png'} />
                        ) : (
                          <img src={imgUrl + '/img/play2.png'} />
                        )}
                      </div>
                    </Tooltip>
                    <Tooltip title="상세보기">
                      <div className="list_img_more">
                        <a
                          style={{ cursor: 'pointer' }}
                          onClick={() => this._goItem(contentSerial)}
                        >
                          더보기
                        </a>
                      </div>
                    </Tooltip>
                    <Tooltip title="찜하기">
                      <div className="list_img_add">
                        <span
                          onClick={this._toggleWish}
                          style={
                            parseInt(wishFlag) > 0
                              ? {
                                  background:
                                    'url(/img/add_on.png) no-repeat center center',
                                }
                              : null
                          }
                        >
                          add
                        </span>
                      </div>
                    </Tooltip>
                    <div className="list_bg1"></div>
                  </Fragment>
                )}
                <div className="list_img_bg" onClick={this._onPlay}>
                  <div className="list_bg1"></div>
                  {opening === null ||
                  opening === '' ||
                  opening === undefined ? (
                    <img
                      src={isHovering ? (overImg === '' ? img : overImg) : img}
                      onClick={() => this._goItem(contentSerial)}
                    />
                  ) : isHovering ? (
                    isMobile ? (
                      <img
                        src={overImg}
                        onClick={() => this._goItem(contentSerial)}
                      />
                    ) : (
                      <div
                        style={{
                          WebkitBorderRadius: 9,
                          MozBorderRadius: 9,
                          borderRadius: 9,
                          overflow: 'hidden',
                          width: wSizeOver,
                          height: hSize,
                        }}
                        onClick={() => this._goItem(contentSerial)}
                      >
                        {' '}
                        {/*width: 493, height: 287*/}
                        <ReactPlayer
                          url={'https://jjmp4.ofscdn.com' + opening}
                          //className='bg_img'
                          playing={true}
                          //url={playUrl}
                          volume={0.5}
                          muted={true}
                          //onReady={this._onReady}
                          //onEnded={this._onEnded}
                          //style={{width: wSize, height: hSize}}
                          width={wSizeOver - 20}
                          height={hSize}
                        />
                      </div>
                    )
                  ) : (
                    <img
                      src={overImg}
                      onClick={() => this._goItem(contentSerial)}
                    />
                  )}
                  {!isHovering ? (
                    refer === 'view' ? (
                      <div className="line_div">
                        <div
                          style={{ width: ratio + '%', height: '100%' }}
                        ></div>
                      </div>
                    ) : null
                  ) : null}
                </div>
                <p
                  onClick={() => this._goItem(contentSerial)}
                  style={{
                    whiteSpace: 'normal',
                    overflowWrap: 'break-word',
                  }} /*style={{fontSize: fSize}}*/
                >
                  {title}
                  <span
                    style={{
                      whiteSpace: 'normal',
                      overflowWrap: 'break-word',
                    }} /*style={{fontSize: fSizeSmail}}*/
                  >
                    {subTitle}
                  </span>
                </p>
              </div>
            </div>
          )}
        </ReactHoverObserver>

        <Modal
          open={modalShow}
          showCloseIcon={false}
          onClose={this._onCloseModal}
          closeOnOverlayClick={false}
          closeOnEsc={false}
          center
          styles={{ modal: { backgroundColor: 'black' } }}
        >
          <UsePoint
            contentSerial={contentSerial}
            contentPartSerial={contentPartSerial}
            subPartSerial2={subPartSerial2 + ','}
            subPartSerial3={subPartSerial3}
            payGubun={payGubun}
            chksale="ppv"
            onPointUse={this._setPointUse}
            onClose={this._onCloseModal}
          />
        </Modal>

        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
        {/*
                <div onMouseEnter={this._onMouseToggle} onMouseLeave={this._onMouseToggle} onClick={()=>this._goItem(contentSerial)}>
                    <img src={img} draggable="false" alt=""/>
                    <div>{title}</div>
                    <div>{subTitle}</div>
                    {refer !== 'update' ? (
                        <Line 
                            percent={(pos / this._timeToMs(mediaTime)) * 100 } 
                            strokeWidth="1.5" 
                            strokeColor="#2db7f5" 
                            trailWidth="1.5"
                            strokeLinecap="round"
                        />
                    ) : null }
                    
                </div>
                */}

        {/*
                <Modal 
                    open={itemShow} onClose={this._onCloseModal} closeOnOverlayClick={false} closeOnEsc={false} center
                >
                    <Items 
                        contentSerial = {contentSerial}
                        onCloseModal = {this._onCloseModal}
                    />
                </Modal>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ContentItemWide));
